import cc from 'classcat';
import { useReducer } from 'react';

import { StickyComponentContext } from './StickyComponent/StickyComponentContext.js';
import styles from './PageWrapper.scss';

const reducer = (state, action) => ({ ...state, ...action });

export function PageWrapper({ className, ...props }) {
  const [stickyContextValue, dispatch] = useReducer(reducer, {
    footerVisible: false,
  });
  return (
    <StickyComponentContext.Provider
      value={{
        footerVisible: stickyContextValue.footerVisible,
        setFooterVisible: (footerVisible) => dispatch({ footerVisible }),
      }}
    >
      <div {...props} className={cc([styles.container, className])} />
    </StickyComponentContext.Provider>
  );
}
